<script setup lang="ts">
  import type { RegionCode } from './all-countries'
  import GatFlag from '../gat-flag/gat-flag.vue'
  import { computed } from 'vue'
  import { phoneCodeMapping } from './all-countries'

  const props = defineProps<{
    regionCode?: RegionCode | (string & {})
  }>()

  const emit = defineEmits<{
    (e: 'click'): void
  }>()

  const dialCode = computed(() => {
    return phoneCodeMapping.find(
      ([_, regionCode, dialCode]) => regionCode === props.regionCode
    )?.[2]
  })

  const countryCode = computed(() => {
    return phoneCodeMapping.find(
      ([_, regionCode, dialCode]) => regionCode === props.regionCode
    )?.[1]
  })
</script>
<template>
  <button
    type="button"
    class="bg-background hover:bg-background-light mr-1 inline-flex cursor-pointer items-center gap-0.5 rounded-md border px-2 py-1 text-sm text-gray-500"
    @click="emit('click')"
  >
    <template v-if="regionCode">
      <gat-flag
        v-if="countryCode"
        :flag="countryCode?.toUpperCase()"
        class="size-4 rounded-full"
      />
      <span v-if="regionCode" class="text-xs">+{{ dialCode }}</span>
    </template>
    <template v-else>
      <gat-icon icon="Earth" class="size-3" />
      <span class="ml-1 text-xs">+xx</span>
    </template>
  </button>
</template>
